import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardShellProvider } from '../context/DashboardShellContext';
import BaseDashboardLayout from './BaseDashboardLayout';
import { getStudentNavSections } from '../components/Sidebar/roleNavConfig';
import StudentAssessmentResumeBar from '../components/student-home/StudentAssessmentResumeBar';

const StudentLayout = () => {
  const sections = useMemo(() => getStudentNavSections(), []);
  const shell = useMemo(
    () => ({
      homePath: '/student/home',
      workspacePath: '/student/dashboard',
      profilePath: '/student/profile',
      projectBasePath: '/student/project',
      codingRoot: null,
      codingActivityPath: null,
    }),
    [],
  );

  return (
    <DashboardShellProvider value={shell}>
      <BaseDashboardLayout brandPath="/student/home" sections={sections} contentMaxWidth={false}>
        <StudentAssessmentResumeBar />
        <Outlet />
      </BaseDashboardLayout>
    </DashboardShellProvider>
  );
};

export default StudentLayout;
